import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { BaseButtonView } from './BaseButtonView';
import { Configuration } from './../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { component } from '../../Decorators/Component';
import { CoreConfig } from '../../../CoreConfig';
export const DenseButtonView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.denseButton,
    style: {
        container: {},
        text: {
            fontSize: 14
        },
        hover: {
            opacity: 0.7
        },
        pressed: {},
        pressedText: {},
        inactive: {},
        disabled: {
            opacity: 0.4
        }
    }
})((props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const [isHovered, setIsHovered] = useState(false);
    const [isPressed, setIsPressed] = useState(false);
    function onHover() {
        setIsHovered(true);
    }
    function onBlur() {
        setIsHovered(false);
    }
    function onPressIn() {
        setIsPressed(true);
    }
    function onPressOut() {
        setIsPressed(false);
    }
    const btnStyles = [
        (_a = props.style) === null || _a === void 0 ? void 0 : _a.container,
        isHovered && !props.disabled && ((_b = props.style) === null || _b === void 0 ? void 0 : _b.hover),
        isPressed && (!props.inactive || !props.disabled) && ((_c = props.style) === null || _c === void 0 ? void 0 : _c.pressed),
        props.disabled && ((_d = props.style) === null || _d === void 0 ? void 0 : _d.disabled),
        props.style,
        props.containerStyle
    ];
    const btnTextStyles = [
        (_e = props.style) === null || _e === void 0 ? void 0 : _e.text,
        isPressed && (!props.inactive || !props.disabled) && ((_f = props.style) === null || _f === void 0 ? void 0 : _f.pressedText),
        props.inactive && ((_g = props.style) === null || _g === void 0 ? void 0 : _g.inactive),
        props.textStyle
    ];
    return _jsx(BaseButtonView, Object.assign({}, props, { containerStyle: btnStyles, textStyle: btnTextStyles, onHover: onHover, onBlur: onBlur, onPressIn: onPressIn, onPressOut: onPressOut, disabled: props.disabled || props.inactive, size: "sm", color: props.color || ((_j = (_h = props.style) === null || _h === void 0 ? void 0 : _h.text) === null || _j === void 0 ? void 0 : _j.color), dense: true }));
});
